import React from 'react';
import moment from 'moment';
import { baseTableColumn } from '@common/components/smartTable/helpers';

export const standartColumnConfig = () => [
  baseTableColumn('Id', 'game_id'),
  baseTableColumn('Round id', 'round_id'),
  baseTableColumn('Team 1', 'team1_name'),
  {
    name: 'score',
    row: (item) => {
      const splitDataToPart = item?.scores?.split('(')[0]?.split(':');
      const scores = splitDataToPart.length > 1 ? splitDataToPart : item?.scores?.split('(')[0].split('-');

      return (
        <div className="virtuals-standart-mode">
          <span className="virtuals-results-scores">{scores[0]}</span>
          -
          <span className="virtuals-results-scores">{scores[1]}</span>
        </div>
      );
    },
  },
  baseTableColumn('Team 1', 'team2_name'),
  baseTableColumn('Competition', 'competition_name'),
  baseTableColumn('Region', 'region_name'),
  {
    name: 'Date',
    row: (item) => moment(item.date * 1000).format('DD-MM-YYYY HH:mm'),
  },
];
